import { useQuestionnaireContext } from '@/app/components/questionnaireV2/context/QuestionnaireContext';
import { useCanSubmit } from '@/app/components/questionnaireV2/hooks/use-can-submit';
import { BaseNextButton, type BaseNextButtonProps } from './base-next-button';

interface NextButtonProps extends Omit<BaseNextButtonProps, 'disabled' | 'loading'> {
  disabled?: boolean;
}

export function NextButton({ onNext, variant = 'primary', text, style, disabled }: NextButtonProps) {
  const { state } = useQuestionnaireContext();
  const canSubmit = useCanSubmit();
  const isDisabled = disabled !== undefined ? disabled : !canSubmit;

  // Show spinner only when loading without skeleton — skeleton provides its own visual feedback
  const showLoader = isDisabled && !state.skeletonQuestion;

  return <BaseNextButton onNext={onNext} variant={variant} text={text} style={style} disabled={isDisabled} loading={showLoader} />;
}
